import React, { useState } from "react";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Grid,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import EmailInput from "../../common/component/EmailInput";
import { isEmailValid } from "../../common/component/util";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import bkstApi from "../../common/component/api";
import { useNavigate } from "react-router";
import CloudinaryUploadWidget from "../../common/component/CloudinaryUploadWidget";

export default function Staff(props) {
  const { siteId, value } = props;
  const navigate = useNavigate();

  const [photo, setPhoto] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [accessCode, setAccessCode] = useState("");

  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let arr = [];
    if (!firstName) {
      arr.push("First Name is missing");
    }
    if (!role) {
      arr.push("Role is missing");
    }
    if (email && !isEmailValid(email)) {
      arr.push("Email is invalid");
    }

    return arr;
  };
  const submit = (e) => {
    e.preventDefault();

    const arr = validate();
    setErrors(arr);
    if (arr.length > 0) {
      return;
    } else {
      setProcessing(true);
      const payload = { photo, firstName, lastName, role, email, accessCode };
      if (value.uid) {
        bkstApi
          .put(`/admin/site/${siteId}/staff/${value.uid}`, payload)
          .then((res) => {
            props.onChange({ ...value, ...payload });
            setProcessing(false);
            setOpen(false);
          })
          .catch((err) => {
            setProcessing(false);
            setErrors([err.response.data.message]);
          });
      } else {
        bkstApi
          .post(`/admin/site/${siteId}/staff`, payload)
          .then((res) => {
            props.onChange({});
            setProcessing(false);
            setOpen(false);
          })
          .catch((err) => {
            setProcessing(false);
            setErrors([err.response.data.message]);
          });
      }
    }
  };

  if (!open) {
    console.log(">>", props.disabled);
    return (
      <span
        onClick={
          props.disabled
            ? undefined
            : () => {
                setFirstName(value.firstName || "");
                setLastName(value.lastName || "");
                setPhoto(value.photo || "");
                setEmail(value.email || "");
                setPhone(value.phone || "");
                setStatus(value.status || "");
                setRole(value.role || "");
                setAccessCode(value.accessCode || "");
                setOpen(true);
              }
        }
        style={props.disabled ? { pointerEvents: "none", cursor: "not-allowed" } : {}}
        aria-disabled={props.disabled ? "true" : undefined}
      >
        {props.children}
      </span>
    );
  } else {
    return (
      <Dialog fullScreen={true} open={open} scroll="paper">
        <form
          onSubmit={submit}
          style={{
            display: "contents"
          }}
        >
          <DialogTitle
            sx={{
              padding: "7px 20px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              margin: "0",
              backgroundColor: "#DEDEDE",
              borderBottom: "3px solid #DEDEDE"
            }}
          >
            <IconButton onClick={() => setOpen(false)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Staff Details</Typography>
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
            <Container maxWidth="md">
              {errors && errors.length > 0 && (
                <Box mb={2}>
                  <Alert severity="error">{errors.join(", ")}</Alert>
                </Box>
              )}
              <Box py={6}>
                <Grid container spacing={3}>
                  <Grid item xs={3} sm={2}>
                    {value.uid && (
                      <Box>
                        <Box sx={{ width: "100%", height: "auto", aspectRatio: "1/1", backgroundColor: "#ECECEC" }}>
                          <img src={photo} width="100%" style={{ objectFit: "cover" }} />
                        </Box>
                        <CloudinaryUploadWidget folder={`s/${siteId}/staff`} onComplete={(images) => setPhoto(images[0])}>
                          <Button variant="contained" color="secondary" fullWidth>
                            Upload
                          </Button>
                        </CloudinaryUploadWidget>
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={9} sm={10}>
                    <Paper elevation={0}>
                      <Box px={2} py={4}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6}>
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                value={firstName}
                                variant="outlined"
                                fullWidth
                                id="firstName"
                                label="First Name"
                                name="firstName"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                value={lastName}
                                variant="outlined"
                                fullWidth
                                id="lastName"
                                label="Last Name"
                                name="lastName"
                                onChange={(e) => setLastName(e.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <FormControl fullWidth required disabled={value.uid}>
                              <InputLabel id="role-label">Role</InputLabel>
                              <Select labelId="role-label" name="role" value={role} label="Role" onChange={(e) => setRole(e.target.value)}>
                                <MenuItem value="owner">Owner</MenuItem>
                                <MenuItem value="manager">Manager</MenuItem>
                                <MenuItem value="clerk">Clerk</MenuItem>
                                <MenuItem value="kitchen">Kitchen</MenuItem>
                                <MenuItem value="kitchen leader">Kitchen Leader</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <EmailInput
                              value={email}
                              onChange={(val) => setEmail(val)}
                              required={role !== "clerk" && role !== "kitchen"}
                              disabled={value.uid}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                value={accessCode}
                                variant="outlined"
                                fullWidth
                                id="accessCode"
                                label="Access Code"
                                name="accessCode"
                                onChange={(e) => setAccessCode(e.target.value)}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                    <Box my={2}>
                      <Button type="submit" fullWidth color="primary" variant="contained">
                        SUBMIT
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </DialogContent>
        </form>
        {processing && (
          <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Dialog>
    );
  }
}
